import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './home/components/Header';
import Footer from './home/components/Footer';
import QuoteForm from './home/components/QuoteForm';
import { siteConfig } from '../config/site';
import { handlePhoneClick } from '../utils/trackPhoneCall';

const imagens = [
  { src: '/images/galeria/obra-01.avif', alt: 'Trabalho de pladur e teto falso - Porto 1' },
  { src: '/images/galeria/obra-02.avif', alt: 'Instalação de pladur em teto - Porto 2' },
  { src: '/images/galeria/obra-03.avif', alt: 'Teto em pladur finalizado - Porto 3' },
  { src: '/images/galeria/obra-04.avif', alt: 'Pladur e pintura - Porto 4' },
  { src: '/images/galeria/obra-05.avif', alt: 'Trabalho de pintura e pladur - Porto 5' },
  { src: '/images/galeria/obra-06.avif', alt: 'Instalação pladur - Porto 6' },
  { src: '/images/galeria/obra-07.avif', alt: 'Pladur teto comercial - Porto 7' },
  { src: '/images/galeria/obra-08.avif', alt: 'Pintura e acabamento - Porto 8' },
  { src: '/images/galeria/obra-09.avif', alt: 'Obra de pladur - Porto 9' },
  { src: '/images/galeria/obra-10.avif', alt: 'Trabalho de remodelação - Porto 10' },
  { src: '/images/galeria/obra-11.avif', alt: 'Pladur paredes - Porto 11' },
  { src: '/images/galeria/obra-12.avif', alt: 'Obra de remodelação pladur - Porto 12' },
  { src: '/images/galeria/obra-13.avif', alt: 'Instalação pladur paredes - Porto 13' },
  { src: '/images/galeria/obra-14.avif', alt: 'Obra pladur e pintura - Porto 14' },
  { src: '/images/galeria/obra-15.avif', alt: 'Pintura profissional - Porto 15' },
];

const servicos = [
  {
    icon: 'ri-brush-line',
    titulo: 'Pintura Interior',
    descricao:
      'Renovação completa de divisões, corredores, tetos e paredes interiores. Preparação de superfícies, primário e acabamento de alta qualidade.',
    image: '/images/galeria/pintura-interior.webp',
  },
  {
    icon: 'ri-home-line',
    titulo: 'Pintura Exterior',
    descricao:
      'Pintura de fachadas, terraços e muros. Tratamento antimofo, impermeabilização e tintas resistentes às condições climatéricas do Porto.',
    image: '/images/galeria/pintura-exterior.webp',
  },
  {
    icon: 'ri-layout-top-line',
    titulo: 'Tetos em Pladur',
    descricao:
      'Instalação e remodelação de tetos falsos em pladur. Isolamento acústico, térmico e soluções de iluminação integrada.',
    image: '/images/galeria/obra-01.avif',
  },
  {
    icon: 'ri-layout-column-line',
    titulo: 'Paredes em Pladur',
    descricao:
      'Divisórias e revestimentos em placas de gesso cartonado. Solução rápida e limpa para criar novos espaços ou redesenhar divisões.',
    image: '/images/galeria/obra-11.avif',
  },
  {
    icon: 'ri-artboard-line',
    titulo: 'Sancas e Rodapés em Pladur',
    descricao:
      'Sancas decorativas, nichos e rodapés em pladur para um acabamento elegante e moderno em qualquer divisão.',
    image: '/images/galeria/sancas-rodapes.webp',
  },
];

const diferenciais = [
  { icon: 'ri-shield-check-line', titulo: 'Materiais de Qualidade', descricao: 'Usamos apenas tintas e placas de marcas certificadas com garantia de durabilidade.' },
  { icon: 'ri-award-line', titulo: 'Acabamento Perfeito', descricao: 'Equipa com vasta experiência para um resultado limpo, uniforme e impecável.' },
  { icon: 'ri-user-star-line', titulo: 'Equipa Especializada', descricao: 'Profissionais certificados com anos de experiência em pintura e pladur no Porto.' },
  { icon: 'ri-file-list-3-line', titulo: 'Orçamento Gratuito', descricao: 'Visita ao local sem compromisso. Orçamento detalhado e transparente antes de começar.' },
];

const PinturaPladur = () => {
  const [lightbox, setLightbox] = useState<number | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const openLightbox = (idx: number) => setLightbox(idx);
  const closeLightbox = () => setLightbox(null);
  const prevImg = () => setLightbox((p) => (p !== null ? (p - 1 + imagens.length) % imagens.length : null));
  const nextImg = () => setLightbox((p) => (p !== null ? (p + 1) % imagens.length : null));

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">

        {/* Hero estilo Home */}
        <section className="relative min-h-screen flex items-end lg:items-center justify-center overflow-hidden">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-no-repeat"
            style={{
              backgroundImage: "url('/images/pintura-pladur-capa.avif')",
              backgroundPosition: "center 30%",
              imageRendering: '-webkit-optimize-contrast',
              WebkitBackfaceVisibility: 'hidden',
              backfaceVisibility: 'hidden',
            }}
          />
          {/* Filtro escuro para destacar o texto */}
          <div className="absolute inset-0 bg-black/45" />

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 lg:pb-20">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left Content */}
              <div className="text-white">
                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
                  <i className="ri-map-pin-line" />
                  Porto e Grande Porto
                </div>
                <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight mb-4">
                  <span
                    className="block"
                    style={{
                      textShadow: '0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(255, 255, 255, 0.6), 0 0 30px rgba(255, 255, 255, 0.4), 0 2px 8px rgba(0, 0, 0, 0.6)'
                    }}
                  >
                    Pintura e Pladur no Porto
                  </span>
                </h1>
                <p
                  className="text-base sm:text-lg lg:text-2xl text-white mb-6"
                  style={{
                    textShadow: '0 0 8px rgba(255, 255, 255, 0.7), 0 0 15px rgba(255, 255, 255, 0.5), 0 2px 4px rgba(0, 0, 0, 0.5)'
                  }}
                >
                  Serviços profissionais de pintura interior, exterior e pladur. Resposta rápida e sem compromisso.
                </p>

                <div className="mt-6 flex flex-wrap gap-4">
                  <a
                    href={`tel:${siteConfig.phone}`}
                    onClick={handlePhoneClick}
                    className="bg-white text-blue-700 hover:bg-gray-100 font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center gap-2"
                  >
                    <i className="ri-phone-line"></i>
                    Ligar agora: {siteConfig.phoneDisplay}
                  </a>
                  <a
                    href="#orcamento"
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center gap-2"
                  >
                    <i className="ri-file-list-3-line"></i>
                    Pedir um orçamento
                  </a>
                </div>

                <div className="mt-8 flex flex-wrap gap-4 text-sm text-blue-200">
                  <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-green-400" />Orçamento Gratuito</span>
                  <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-green-400" />Materiais Certificados</span>
                  <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line text-green-400" />Trabalho com Garantia</span>
                </div>
              </div>

              {/* Right Column empty to keep layout */}
              <div className="hidden lg:block"></div>
            </div>
          </div>
        </section>


        {/* Badges profissionais */}
        <section className="bg-white border-y border-gray-100 py-6">
          <div className="max-w-5xl mx-auto px-4">
            <div className="flex flex-wrap justify-center items-center gap-8">
              {[
                { icon: 'ri-file-list-3-line', label: 'Orçamento Gratuito' },
                { icon: 'ri-medal-line', label: 'Materiais Certificados' },
                { icon: 'ri-shield-check-line', label: 'Trabalho com Garantia' },
                { icon: 'ri-map-pin-2-line', label: 'Porto e Grande Porto' },
                { icon: 'ri-time-line', label: 'Resposta Rápida' },
              ].map((badge, i) => (
                <div key={i} className="flex items-center gap-2 text-gray-600">
                  <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <i className={`${badge.icon} text-blue-600 text-base`} />
                  </div>
                  <span className="text-sm font-medium text-gray-700 whitespace-nowrap">{badge.label}</span>
                  {i < 4 && <span className="ml-8 hidden md:block w-px h-5 bg-gray-200" />}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Parceiros de Confiança */}
        <section className="bg-gray-50/60 py-10 border-b border-gray-100">
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h3 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-6">
              Parceiros de Confiança / Clientes de Destaque
            </h3>
            <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24">
              <div className="flex flex-col items-center gap-2 group">
                <div className="h-14 flex items-center justify-center">
                  <img
                    src="/images/logo-worten.webp"
                    alt="Worten Logo"
                    className="h-10 md:h-12 object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>
                <span className="text-[10px] uppercase font-bold tracking-wider text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">Parceiro Oficial</span>
              </div>
              <div className="flex flex-col items-center gap-2 group">
                <div className="h-14 flex items-center justify-center">
                  <img
                    src="/images/logo-fitnessup.webp"
                    alt="Fitness UP Logo"
                    className="h-9 md:h-11 object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>
                <span className="text-[10px] uppercase font-bold tracking-wider text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">Parceiro Oficial</span>
              </div>
            </div>
          </div>
        </section>

        {/* Serviços */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Os Nossos Serviços</h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Do projeto à execução — oferecemos soluções completas de pintura e pladur para habitação e comércio.
              </p>
            </div>

            <div className="space-y-24">
              {servicos.map((s, index) => {
                const isEven = index % 2 === 0;
                return (
                  <div key={s.titulo} className="grid lg:grid-cols-2 gap-12 items-center">
                    {/* Imagem */}
                    <div className={`w-full ${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                      <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-video w-full max-w-lg mx-auto group">
                        <img
                          src={s.image}
                          alt={s.titulo}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                      </div>
                    </div>

                    {/* Conteúdo */}
                    <div className={`space-y-4 ${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
                      <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-50 rounded-xl mb-2">
                        <i className={`${s.icon} text-2xl text-blue-600`} />
                      </div>
                      <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
                        {s.titulo}
                      </h3>
                      <p className="text-gray-600 text-lg leading-relaxed">
                        {s.descricao}
                      </p>
                      <div className="pt-4 flex flex-wrap gap-4">
                        <a
                          href={`tel:${siteConfig.phone}`}
                          onClick={handlePhoneClick}
                          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center gap-2"
                        >
                          <i className="ri-phone-line" />
                          Ligar agora
                        </a>
                        <a
                          href="#orcamento"
                          className="bg-white hover:bg-gray-50 text-blue-600 font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center gap-2 border border-blue-600"
                        >
                          <i className="ri-file-list-3-line" />
                          Pedir Orçamento
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Porquê escolher-nos */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Porquê Escolher-nos?</h2>
              <p className="text-gray-600 text-lg">Comprometemo-nos com a qualidade e a satisfação de cada cliente.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              {diferenciais.map((d) => (
                <div key={d.titulo} className="flex gap-5 items-start bg-white rounded-xl p-6 shadow-sm">
                  <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${d.icon} text-xl text-white`} />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-gray-900 mb-1">{d.titulo}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{d.descricao}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Galeria de Obras */}
        <section className="py-20 bg-white" id="galeria">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-4">
                <i className="ri-image-line" />
                Trabalhos Realizados
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Galeria de Obras</h2>
              <p className="text-gray-600 text-lg max-w-xl mx-auto">
                Veja alguns dos nossos trabalhos de pintura e pladur no Porto e Grande Porto.
              </p>
            </div>

            {/* Grid dinâmico */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
              {(isExpanded ? imagens : imagens.slice(0, 8)).map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => openLightbox(idx)}
                  className="group relative aspect-square overflow-hidden rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
                  aria-label={`Ver ${img.alt}`}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white text-blue-700 rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-2">
                      <i className="ri-zoom-in-line" />
                      Ampliar
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <div className="text-center">
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-xl transition-colors shadow-md hover:shadow-lg"
              >
                <i className="ri-gallery-line text-lg" />
                {isExpanded ? 'Mostrar menos fotos' : `Ver todas as fotos (${imagens.length})`}
                <i className={isExpanded ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
              </button>
            </div>
          </div>
        </section>

        {/* Formulário de Orçamento */}
        <section className="py-16 bg-gray-50" id="orcamento">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
              <QuoteForm />
            </div>
          </div>
        </section>

        {/* CTA Ligar */}
        <section className="py-16 bg-blue-700 text-white text-center">
          <div className="max-w-2xl mx-auto px-4">
            <h2 className="text-3xl font-bold mb-4">Precisa de pintura ou pladur no Porto?</h2>
            <p className="text-blue-200 mb-8 text-lg">Ligue agora e receba um orçamento gratuito sem compromisso.</p>
            <a
              href={`tel:${siteConfig.phone}`}
              onClick={handlePhoneClick}
              className="bg-white text-blue-700 font-bold px-10 py-4 rounded-xl hover:bg-blue-50 transition-colors inline-flex items-center gap-3 text-lg shadow-lg"
            >
              <i className="ri-phone-fill" />
              {siteConfig.phoneDisplay}
            </a>
          </div>
        </section>

        {/* Voltar */}
        <section className="py-8 bg-gray-50 text-center">
          <Link to="/" className="text-blue-600 hover:underline inline-flex items-center gap-2 text-sm font-medium">
            <i className="ri-arrow-left-line" />
            Voltar à página inicial
          </Link>
        </section>

      </main>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 transition-colors z-10"
            onClick={closeLightbox}
            aria-label="Fechar"
          >
            <i className="ri-close-line" />
          </button>
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white text-4xl hover:text-gray-300 transition-colors z-10 bg-black/40 rounded-full w-12 h-12 flex items-center justify-center"
            onClick={(e) => { e.stopPropagation(); prevImg(); }}
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <img
            src={imagens[lightbox].src}
            alt={imagens[lightbox].alt}
            className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white text-4xl hover:text-gray-300 transition-colors z-10 bg-black/40 rounded-full w-12 h-12 flex items-center justify-center"
            onClick={(e) => { e.stopPropagation(); nextImg(); }}
            aria-label="Próxima"
          >
            <i className="ri-arrow-right-line" />
          </button>
          <div className="absolute bottom-4 text-white/70 text-sm">
            {lightbox + 1} / {imagens.length}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default PinturaPladur;
